import CustomerNotes from "./CustomerNotes";
export default CustomerNotes;
